module.exports = __webpack_public_path__ + "img/png_home_title.6b72402d.png";